import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { OrderServices } from "../services/OrderServices";
import OrderConfirm from "../components/OrderConfirm";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const PayPalSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState("");
  const [orderSuccess, setOrderSuccess] = useState(null);

  useEffect(() => {
    const executePayment = async () => {
      const paymentId = searchParams.get("paymentId");
      const payerId = searchParams.get("PayerID");
      const orderId = searchParams.get("order_id");

      if (!paymentId || !payerId || !orderId) {
        setError("Missing payment information. Please contact support.");
        setProcessing(false);
        return;
      }

      try {
        const res = await OrderServices.executePayPalPayment(
          paymentId,
          payerId,
          parseInt(orderId, 10)
        );

        if (res.success) {
          setOrderSuccess(res.order);
          window.dispatchEvent(new Event("cart_updated"));
        } else {
          setError(res.message || "Payment execution failed.");
        }
      } catch (err) {
        console.error("PayPal execution error:", err);

        setError(
          err?.response?.data?.message ||
            "Failed to complete payment. Please contact support."
        );
      } finally {
        setProcessing(false);
      }
    };

    executePayment();
  }, [searchParams]);

  if (processing) {
    return (
      <>
        <BreadcrumbTwo title="Processing Payment" />

        <section
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: "2rem",
          }}
        >
          <div
            className="spinner-border mb-3"
            style={{
              color: "#f27b21",
              width: "3rem",
              height: "3rem",
            }}
          />

          <h4 style={{ color: "#344054", marginBottom: "0.5rem" }}>
            Processing Your Payment
          </h4>

          <p style={{ color: "#667085", fontSize: "14px" }}>
            Please wait while we confirm your PayPal payment...
          </p>
        </section>
      </>
    );
  }

  if (error) {
    return (
      <>
        <BreadcrumbTwo title="Payment Failed" />

        <section
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              textAlign: "center",
              background: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: "12px",
              padding: "2rem",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>❌</div>

            <h3 style={{ color: "#dc2626", marginBottom: "1rem" }}>
              Payment Failed
            </h3>

            <p style={{ color: "#991b1b", marginBottom: "1.5rem" }}>
              {error}
            </p>

            <button
              onClick={() => navigate("/cart")}
              className="btn btn-main py-14 px-24 rounded-8"
            >
              Return to Cart
            </button>
          </div>
        </section>
      </>
    );
  }

  if (orderSuccess) {
    return (
      <OrderConfirm
        order={orderSuccess}
        currencySymbol={orderSuccess.currency_symbol || "$"}
      />
    );
  }

  return null;
};

export default PayPalSuccessPage;